import { Outlet } from "react-router-dom";

import { FilterPatientProvider } from "./filter-patient/filter-patient.context";
import './patient.scss';

export function Patient() {
  return (
    <div id="ShellPatient" className="patient">
       <FilterPatientProvider>
        <Outlet />
      </FilterPatientProvider>
    </div>
  );
}

export default Patient;
